/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _matchesSelector = _interopRequireDefault(require("./matchesSelector"));
var FOCUSABLE_SELECTOR = 'input, select, textarea, button, object, a[href], [tabindex]';
var _default = function _default(element) {
  return (0, _matchesSelector.default)(element, FOCUSABLE_SELECTOR);
};
exports.default = _default;